import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Output,
  Input,
  EventEmitter,
} from "@angular/core";
import { ToggleService } from "src/app/services/toggle.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  constructor(private readonly toggleService: ToggleService) {}
  @Output() toggleRatingModelEV = new EventEmitter<number>();
  @Output() clearMessages = new EventEmitter<any>();

  @Input() chatbot_lang;
  closeCount:number = 0
  ngOnInit() {
    window.addEventListener("message", (event) => {
      if (event.origin !== "https://testportal.omantel.om") {
        console.warn("Untrusted message origin:", event.origin);
        return;
      }
      console.log("Message received from parent:", event.data);
    });
  }
  toggleChatBot(num: number) {
      if (num == 2){
        // this.clearMessages.emit();
        this.toggleRatingModelEV.emit()
        // this.closeCount=this.closeCount+1
        // num = 0;
      } else {
        this.toggleService.toggleChatbot(num);
      }
  }
}
